/**
 * Site-wide SEO and metadata config. Update with your production URL and assets.
 */
export const SITE_CONFIG = {
  name: "BalkanFinXpert",
  shortName: "BalkanFinXpert",
  /** Production URL (no trailing slash). Use env in build if needed. */
  url:
    typeof process !== "undefined" && process.env?.REACT_APP_SITE_URL
      ? String(process.env.REACT_APP_SITE_URL).replace(/\/$/, "")
      : "https://balkanfin.com",
  defaultTitle: "BalkanFinXpert | Business & Finance Experts",
  defaultDescription:
    "Счетоводна и консултантска къща. Професионално счетоводно обслужване, данъчно и финансово консултиране за малкия, средния и големия бизнес.",
  defaultDescriptionEn:
    "Accounting and consulting firm. Professional accounting, tax and financial consulting for small, medium and large business.",
  /** Absolute URL to default OG image (e.g. logo or hero). 1200x630 recommended. */
  ogImage: "/images/og-image.png",
  twitterCard: "summary_large_image" as const,
  locale: "bg_BG",
  alternateLocales: ["en_US"],
  /** For JSON-LD Organization / LocalBusiness */
  address: {
    streetAddress: "84 Aleksandar Stamboliyski str., fl. 5, ap. 23",
    addressLocality: "Sofia",
    postalCode: "1303",
    addressRegion: "Sofia City",
    addressCountry: "BG",
  },
  /** Approximate geo coordinates for the Sofia office (LocalBusiness schema). */
  geo: {
    latitude: 42.6977,
    longitude: 23.3219,
  },
  /** Office hours in schema.org OpeningHoursSpecification format. */
  openingHours: [
    {
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "18:00",
    },
  ],
  /** Year the firm was founded – appears in LocalBusiness schema. */
  foundingDate: "2026",
  /** Social profiles for sameAs in JSON-LD. Add LinkedIn / Facebook when available. */
  sameAs: [] as string[],
  phone: "+359 88 366 8499",
  email: "info@balkanfin.com",
  /** Backend API base URL for inquiry form (e.g. http://localhost:3001). */
  apiBaseUrl:
    typeof process !== "undefined" && process.env?.REACT_APP_API_URL
      ? String(process.env.REACT_APP_API_URL).replace(/\/$/, "")
      : "",
};

export type SiteConfig = typeof SITE_CONFIG;
